import * as React from "react";
import { useIntl } from "react-intl";
import { ChakraProvider } from "@chakra-ui/react";
import theme from "../components/theme";
import Layout from "../components/layout";
import Seo from "../components/seo";
import { Box } from "@chakra-ui/react";
import Demo from "../components/demo"
import CallToActionWithVideo from "../components/cta";
import Sections from "../components/sections";
import Pricing from "../components/pricing";
import Faqs from "../components/faqs";

const Background = ({ children, color1, color2 }) => (
  <Box bgGradient={`radial-gradient(${color1} 0%, ${color2} 100%)`}>
    {children}
  </Box>
);

const IndexPage = ({ pageContext }) => {
  const { locale } = pageContext; // Pobranie locale z pageContext
  return (
    <Layout>
      <Background color1="purple.50" color2="white">
        <CallToActionWithVideo />
      </Background>
      <Background color1="white.50" color2="white">
        <Sections />
      </Background>
      <Background color1="purple.50" color2="white">
        <Demo />
      </Background>
      <Background color1="white.50" color2="white">
        <Pricing />
      </Background>
      <Background color1="purple.50" color2="white">
        <Faqs />
      </Background>
    </Layout>
  );
};

// Użycie `useIntl` do tłumaczeń w `Head`
export const Head = ({ pageContext }) => {
  const intl = useIntl();
  return (
    <Seo
      title={intl.formatMessage({ id: "seoTitle" })}
      description={intl.formatMessage({ id: "seoDescription" })}
    />
  );
};

export default IndexPage;
